import { render, staticRenderFns } from "./comments-lightbox.vue?vue&type=template&id=f2de29ba"
import script from "./comments-lightbox.vue?vue&type=script&lang=ts"
export * from "./comments-lightbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2de29ba')) {
      api.createRecord('f2de29ba', component.options)
    } else {
      api.reload('f2de29ba', component.options)
    }
    module.hot.accept("./comments-lightbox.vue?vue&type=template&id=f2de29ba", function () {
      api.rerender('f2de29ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitor-details/comments/comments-lightbox.vue"
export default component.exports